import config from '@/config';
import axios from 'axios';

const { get, patch, post, put } = axios;

export const getCase = caseId => get(`/v1/cases/${caseId}/`);
export const patchAnchor = (caseId, anchor) => patch(`/v1/cases/${caseId}/`, { anchor });
export const balanceCase = caseId => post(`/v1/cases/${caseId}/balance/`);
export const createCostOverride = (caseId, data) => post(`/v1/cases/${caseId}/cost_overrides/`, data);
export const patchCostOverride = (costId, data) => patch(`/v1/cost_overrides/${costId}/`, data);
export const deleteCostOverride = costId => axios.delete(`/v1/cost_overrides/${costId}/`);
export const analyzeCase = (caseId, params) => post(`/v1/cases/${caseId}/analyze/`, { ...(params ? params : {}) });
export const duplicateCase = (caseId, params) => post(`/v1/cases/${caseId}/duplicate/`, params ?? {});
export const patchPositions = (caseId, positions) => patch(`/v1/cases/${caseId}/`, { node_info: positions });
export const updateEdgeControlPoint = (caseId, edge) => put(`/v1/cases/${caseId}/edges/`, edge);
export const getCaseNodesWithParams = caseId => get(`/v1/cases/${caseId}/params/`);
export const patchCaseParams = (caseId, params) => patch(`/v1/cases/${caseId}/params/`, params);
export const exportCaseDataUrl = caseId => `${config.serverUrl}/v1/cases/${caseId}/export/`;
